import { useFragment, graphql } from 'react-relay';

import { type useShowReturns_item$key } from './__generated__/useShowReturns_item.graphql.ts';

const itemFragment = graphql`
    fragment useShowReturns_item on Item {
        returnPolicy(userId: $userId) @include(if: $afterDisplay) {
            returnDays(userCountryCode: $userCountryCode, includeEuReturns: true)
        }
    }
`;

export const useShowReturns = ({
    item: itemRef,
}: {
    item?: useShowReturns_item$key | null;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);

    return !!item?.returnPolicy?.returnDays;
};
